"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRemoveMagicZoomFromDOM = void 0;
var _react = require("react");
const useRemoveMagicZoomFromDOM = () => {
  (0, _react.useEffect)(() => () => {
    // html tag
    document.documentElement?.classList.remove('mac-magic', 'svg-magic');
    // css section
    const magiczoomResetCss = document.getElementById('magiczoom-reset-css');
    const mzRuntimeCss = document.getElementById('mz-runtime-css');
    const magic360CssReset = document.getElementById('magic360-css-reset');
    magiczoomResetCss?.remove();
    mzRuntimeCss?.remove();
    magic360CssReset?.remove();

    // bottom - before </body>
    const magicHiddenWrappers = document.getElementsByClassName('magic-hidden-wrapper');
    const m360TmpHdnConts = document.getElementsByClassName('m360-tmp-hdn-cont');
    const magicFullscreen = document.getElementsByClassName('Magic360-fullscreen');
    const magicTemporaryImages = document.getElementsByClassName('magic-temporary-img');
    const domElementsToRemove = [...magicHiddenWrappers, ...m360TmpHdnConts, ...magicFullscreen, ...magicTemporaryImages];
    for (const element of domElementsToRemove) {
      element.remove();
    }
  }, []);
};
exports.useRemoveMagicZoomFromDOM = useRemoveMagicZoomFromDOM;
//# sourceMappingURL=useRemoveMagicZoomFromDOM.js.map